import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// import Model from '../views/Model.vue'
// import Help from "../views/Help";

Vue.use(VueRouter);

const routes = [
    // Einstieg (Ladebildschirm)
    {
        path: '/',
        component: Home,
        meta: {
            title: 'Start'
        }
    },
    // Hilfe
    // {
    //     path: '/help',
    //     component: Help
    //     //component: () => import(/* webpackChunkName: "help" */ '../views/Help.vue')
    // },

    // 3D Modell
    // {
    //     path: '/model',
    //     component: Model,
    //     meta: {  
    //         title: 'Model'
    //     }
    // },

    {
        path: '/cannabis',
        component: () => import('../views/010_Cannabis.vue'),
    },

    {
        path: '/thccbd',
        component: () => import('../views/020_THCCBD.vue'),
    },

    {
        path: '/vergleich',
        component: () => import('../views/030_Vergleich.vue'),
    },

/*     {
        path: '/glasmann', 
        component: () => import('../views/040_Glasmann.vue'),
    }, */

    {
        path: '/endosysteme', 
        component: () => import('../views/050_Endosystem.vue'),
    },

    {
        path: '/gehirn', 
        component: () => import('../views/060_Gehirn.vue'),
    },

   /*  {
        path: '/schluesselschloss', 
        component: () => import('../views/065_Schluesselschloss.vue'),
    }, */

    {
        path: '/wirkungsweise',
        component: () => import('../views/070_Wirkungsweise.vue')
    },
    // Credits
    {
        path: '/Credits',
        component: () => import('../views/Credits.vue'),
    },

];

const router = new VueRouter({
    // mode: abstract, history, hash
    mode: process.env.VUE_APP_ROUTER_MODE ? process.env.VUE_APP_ROUTER_MODE : 'abstract',
    base: process.env.BASE_URL,
    routes
});

export default router
